(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hwc-footer"]) return;
  try {
    
document.addEventListener('click', event => {
  const link = event.target instanceof Element
    ? event.target.closest('.hwc-footer__policies a[href$="#shopifyReshowConsentBanner"]')
    : null;
  if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
  event.preventDefault();
  window.privacyBanner.showPreferences().catch(() => {
    console.error('Cookie preferences could not be opened.');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hwc-header"]) return;
  try {
    
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.hwc-mobile-menu[open]').forEach(menu => {
    menu.removeAttribute('open');
    menu.querySelector('summary')?.focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
